export const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_agro-blocks/artifacts/pv2ji98h_IMG_6305.jpeg";

export const STAGE_META = {
  "Growing Phase": { short: "Growing", color: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10", dot: "bg-emerald-400" },
  "Harvested & Warehoused": { short: "Harvested", color: "text-amber-300 border-amber-500/40 bg-amber-500/10", dot: "bg-amber-400" },
  "In Shipping Container (Port)": { short: "At Port", color: "text-sky-300 border-sky-500/40 bg-sky-500/10", dot: "bg-sky-400" },
  "In Transit": { short: "In Transit", color: "text-blue-300 border-blue-500/40 bg-blue-500/10", dot: "bg-blue-400" },
  "Market Sale Completed": { short: "Sold", color: "text-fuchsia-300 border-fuchsia-500/40 bg-fuchsia-500/10", dot: "bg-fuchsia-400" },
};

export const STATUS_META = {
  open: { label: "Open for Funding", color: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30" },
  funded: { label: "Fully Funded", color: "text-amber-300 bg-amber-500/10 border-amber-500/30" },
  purchased: { label: "Purchased", color: "text-sky-300 bg-sky-500/10 border-sky-500/30" },
  sold: { label: "Sold & Distributed", color: "text-fuchsia-300 bg-fuchsia-500/10 border-fuchsia-500/30" },
  closed: { label: "Closed", color: "text-slate-300 bg-slate-500/10 border-slate-500/30" },
};

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const money2 = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

export const CROP_IMAGES = {
  default: "https://images.unsplash.com/photo-1634651423818-d8decca1934a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};
